<template>
  <main>
    <b-container>
      <div class="section-header">
        <div>
          <h1 class="m-0">Users</h1>
        </div>

        <div class="actions">
          <div class="action">
            <b-form-input
              v-model="search"
              placeholder="Search…"
              class=""
            ></b-form-input>
          </div>
        </div>
      </div>

      <b-row>
        <b-col>
          <div class="layoutcard">
            <!-- This table is for loading placeholders.
            Use this when you implement lazy loading. -->
            <!-- <table class="table table-hover vertical-align-middle">
              <thead>
                <tr>
                  <th>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </th>
                  <th>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </th>
                  <th>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </th>
                  <th>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table> -->

            <b-table
              :show-empty="true"
              :items="users"
              :fields="fields"
              :filter="search"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by="'user_name'"
              class="table-hover vertical-align-middle"
            >
              <template v-slot:cell(user_name)="data">
                <router-link
                  :to="{ name: 'UserView', params: { id: data.item._id } }"
                  >{{ data.item.user_name }}</router-link
                >
              </template>

              <template v-slot:cell(full_name)="data">
                {{
                  data.item.full_name == "null null"
                    ? "---"
                    : data.item.full_name
                }}
              </template>

              <!--
              <template v-slot:cell(projects)="data">
                {{ getUserProjects(data.item) }}
              </template>
              <template v-slot:cell(actions)="data">
                <b-btn-group>
                  <b-btn variant="link-dark" size="sm" @click="confirmDelete(data.item)" class="ml-1">
                    <i class="fa fa-trash" />
                  </b-btn>
                </b-btn-group>
              </template>
              -->
            </b-table>

            <b-row align-h="center" class="mt-4" v-if="totalRows > perPage">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
              ></b-pagination>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <!--
      <b-row>
        <b-col class="text-right">
          <b-btn variant="primary" size="lg" @click="$router.push({ name: 'UserCreate' })"><i class="fa fa-plus" /> New user</b-btn>
        </b-col>
      </b-row>
      -->
    </b-container>
  </main>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import InitAdmin from "../Shared/InitAdmin";

export default {
  name: "UserIndex",
  extends: InitAdmin,
  data() {
    return {
      search: "",
      currentPage: 1,
      perPage: 10,
      fields: [
        {
          key: "user_name",
        },
        {
          key: "full_name",
        },
        {
          key: "email",
        },
        {
          key: "created",
        },
        //{
        //  key: "projects",
        //  tdClass: "small"
        //}
        // {
        //   key: 'actions',
        //   tdClass: 'text-right',
        //   label: '',
        // }
      ],
    };
  },
  computed: {
    ...mapGetters(["projects"]),
    ...mapState({
      users: (state) => state.user.users,
    }),
    totalRows() {
      return this.users ? this.users.length : null;
    },
  },
  mounted() {
    this.loadProjects();
    this.loadUsers();
  },
  methods: {
    ...mapActions(["loadProjects", "loadUsers"]),
    getUserProjects(user) {
      return this.projects
        .filter((p) => {
          return p.users.some((u) => u.user === user._id);
        })
        .map((p) => p.name)
        .join(", ");
    },
  },
};
</script>
